import { Injectable } from '@angular/core';
import { openDB, IDBPDatabase } from 'idb';

@Injectable({
  providedIn: 'root'
})
export class IndexedDbService {
  private dbName = 'formDatabase';
  private storeName = 'formDataStore';
  private db!: IDBPDatabase;

  constructor() {}

  async initDB(): Promise<void> {
    this.db = await openDB(this.dbName, 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains('formDataStore')) {
          db.createObjectStore('formDataStore'); // 🔥 Garante que a store será criada
        }
      }
    });
    //console.log('✅ IndexedDB inicializado!');
  }

  async salvarDados(dados: any) {
    try {
      if (!this.db) await this.initDB();
      await this.db.put(this.storeName, dados, 'formData');
    } catch (error) {
      console.error('Erro ao salvar dados:', error);
    }
  }
  
  async obterDados() {
    try {
      if (!this.db) await this.initDB();
      if (!this.db.objectStoreNames.contains(this.storeName)) {
        console.warn('⚠️ A store ainda não foi criada. Nenhum dado disponível.');
        return null;
      }
      return await this.db.get(this.storeName, 'formData');
    } catch (error) {
      console.error('Erro ao obter dados:', error);
      return null;
    }
  }
  
  async limparCache() {
    try {
      if (!this.db) await this.initDB();
      await this.db.delete(this.storeName, 'formData');
    } catch (error) {
      console.error('Erro ao limpar cache:', error);
    }
  }
}
